import React, { useMemo, useState } from 'react';
import GeoReadOnly from './GeoReadOnly';
import GeoMapModal from './GeoMapModal';

type Policy = {
  geo?: { bboxes?: any[]; circles?: any[] };
  geoByService?: Record<string, { bboxes?: any[]; circles?: any[] }>;
};

export default function AccessPolicyCard({ policy, svcId }: { policy: Policy | null; svcId: string }) {
  const [showMap, setShowMap] = useState(false);

  const geo = useMemo(() => {
    const bySvc = (policy?.geoByService || {})[svcId];
    return bySvc || (policy?.geo || { bboxes: [], circles: [] });
  }, [policy, svcId]);

  return (
    <>
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="row" style={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <h3 style={{ margin: 0 }}>Access Policy</h3>
          <button className="btn info" onClick={() => setShowMap(true)}>Map View</button>
        </div>
        <div className="muted" style={{ marginBottom: 8 }}>The following geographic constraints apply to this service. Your account manager configures this access policy; contact support or your Account Manager to request changes.</div>
        <GeoReadOnly bboxes={(geo.bboxes || [])} circles={(geo.circles || [])} />
      </div>
      <GeoMapModal open={showMap} onClose={() => setShowMap(false)} bboxes={(geo.bboxes || [])} circles={(geo.circles || [])} title="Access Policy Map" />
    </>
  );
}

